const BASE_URL = "http://localhost:8181/cxs";
const username = "karaf";
const password = "karaf";

const authHeader = {
  "Authorization": "Basic " + btoa(`${username}:${password}`),
  "Content-Type": "application/json",
};


  
export const fetchProfiles = async (limit = 10) => {
    const response = await fetch(`${BASE_URL}/profiles/search`, {
      method: "POST",
      headers: authHeader,
      body: JSON.stringify({ offset: 0, limit, condition: { type: "booleanCondition", parameterValues: { operator: "and", subConditions: [] } } }),
    });
    return response.json();
  };
  
  export const fetchEvents = async (limit = 10, offset = 0) => {
    const response = await fetch(`${BASE_URL}/events/search`, {
      method: "POST",
      headers: authHeader,
      body: JSON.stringify({
        offset,
        limit,
        condition: {
          type: "booleanCondition",
          parameterValues: {
            operator: "and",
            subConditions: []
          }
        }
      }),
    });
    return response.json();
  };

  export const fetchSegments = async () => {
    const response = await fetch(`${BASE_URL}/segments`, { headers: authHeader });
    return response.json();
  };
  
  export const fetchCampaigns = async () => {
    const response = await fetch(`${BASE_URL}/campaigns/search`, {
      method: "POST",
      headers: authHeader,
      body: JSON.stringify({
        offset: 0,
        limit: 50,
        condition: {
          type: "booleanCondition",
          parameterValues: {
            operator: "and",
            subConditions: []
          }
        }
      }),
    });
    return response.json();
  };

// Fetch Privacy Information
export const fetchPrivacyInfo = async () => {
  const response = await fetch(`${BASE_URL}/privacy/info`, { headers: authHeader });
  return response.json();
};

// Fetch Context API Data
export const fetchContext = async () => {
  const response = await fetch(`${BASE_URL}/context.json`, { headers: authHeader });
  return response.json();
};

// Delete Profile
export const deleteProfile = async (profileId) => {
  return fetch(`${BASE_URL}/privacy/profiles/${profileId}`, {
    method: "DELETE",
    headers: authHeader,
  });
};

export const fetchRules = async () => {
    const response = await fetch(`${BASE_URL}/rules`, { headers: authHeader });
    return response.json();
  };
  
  export const createRule = async (ruleData) => {
    return fetch(`${BASE_URL}/rules`, {
      method: "POST",
      headers: authHeader,
      body: JSON.stringify(ruleData),
    });
  };
  
  export const deleteRule = async (ruleId) => {
    return fetch(`${BASE_URL}/rules/${ruleId}`, {
      method: "DELETE",
      headers: authHeader,
    });
  };
  export const fetchProfileById = async (profileId) => {
    const response = await fetch(`${BASE_URL}/profiles/${profileId}`, { headers: authHeader });
    return response.json();
  };
    
export const createSegment = async (segmentData) => {
  try {
    const response = await fetch(`${BASE_URL}/segments`, {
      method: 'POST',
      headers: authHeader,
      body: JSON.stringify({
        metadata: {
          id: segmentData.name.toLowerCase().replace(/\s+/g, '-'),
          name: segmentData.name,
          description: segmentData.description,
          scope: 'CDP',
          tags: ['CDP', 'segment']
        },
        condition: {
          type: 'profilePropertyCondition',
          parameterValues: {
            propertyName: segmentData.condition.propertyName,
            comparisonOperator: segmentData.condition.comparisonOperator,
            propertyValue: segmentData.condition.propertyValue
          }
        }
      }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to create segment');
    }
    
    const data = await response.json();
    // Ensure the returned data has the correct structure
    return {
      metadata: {
        id: data.itemId || data.metadata?.id,
        name: data.name || data.metadata?.name,
        description: data.description || data.metadata?.description
      },
      condition: {
        type: data.condition?.type || 'profilePropertyCondition',
        parameterValues: {
          propertyName: data.condition?.parameterValues?.propertyName || '',
          comparisonOperator: data.condition?.parameterValues?.comparisonOperator || 'equals',
          propertyValue: data.condition?.parameterValues?.propertyValue || ''
        }
      }
    };
  } catch (error) {
    console.error('Error creating segment:', error);
    throw error;
  }
};

// Add this new function to edit segments
export const editSegment = async (segmentId, segmentData) => {
  try {
    const response = await fetch(`${BASE_URL}/segments/${segmentId}`, {
      method: 'PATCH',
      headers: authHeader,
      body: JSON.stringify({
        metadata: {
          id: segmentId,
          name: segmentData.name,
          description: segmentData.description,
          scope: 'CDP',
          tags: ['CDP', 'segment']
        },
        condition: {
          type: 'profilePropertyCondition',
          parameterValues: {
            propertyName: segmentData.condition.propertyName,
            comparisonOperator: segmentData.condition.comparisonOperator,
            propertyValue: segmentData.condition.propertyValue
          }
        }
      }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to update segment');
    }
    
    const data = await response.json();
    // Ensure the returned data has the correct structure
    return {
      metadata: {
        id: data.itemId || data.metadata?.id,
        name: data.name || data.metadata?.name,
        description: data.description || data.metadata?.description
      },
      condition: {
        type: data.condition?.type || 'profilePropertyCondition',
        parameterValues: {
          propertyName: data.condition?.parameterValues?.propertyName || '',
          comparisonOperator: data.condition?.parameterValues?.comparisonOperator || 'equals',
          propertyValue: data.condition?.parameterValues?.propertyValue || ''
        }
      }
    };
  } catch (error) {
    console.error('Error updating segment:', error);
    throw error;
  }
};

// Add these context-related functions to your api.js

export const fetchContexts = async () => {
  const response = await fetch(`${BASE_URL}/context.json`, { headers: authHeader });
  return response.json();
};

export const createContext = async (contextData) => {
  try {
    const response = await fetch(`${BASE_URL}/context.json`, {
      method: 'POST',
      headers: authHeader,
      body: JSON.stringify({
        source: {
          itemId: contextData.name.toLowerCase().replace(/\s+/g, '-'),
          itemType: 'context',
          name: contextData.name,
          description: contextData.description,
          scope: contextData.scope || 'CDP',
          tags: ['CDP', 'context']
        },
        properties: contextData.properties,
        requiresCallBack: contextData.requiresCallBack || false,
        filters: contextData.filters || []
      }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to create context');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error creating context:', error);
    throw error;
  }
};

export const editContext = async (contextId, contextData) => {
  try {
    const response = await fetch(`${BASE_URL}/context/${contextId}`, {
      method: 'PATCH',
      headers: authHeader,
      body: JSON.stringify({
        source: {
          itemId: contextId,
          itemType: 'context',
          name: contextData.name,
          description: contextData.description,
          scope: contextData.scope || 'CDP',
          tags: ['CDP', 'context']
        },
        properties: contextData.properties,
        requiresCallBack: contextData.requiresCallBack || false,
        filters: contextData.filters || []
      }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to update context');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error updating context:', error);
    throw error;
  }
};

// Add these campaign-related functions
export const createCampaign = async (campaignData) => {
  const response = await fetch(`${BASE_URL}/campaigns`, {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      metadata: {
        id: campaignData.name.toLowerCase().replace(/\s+/g, '-'),
        name: campaignData.name,
        description: campaignData.description,
        scope: "CDP",
        tags: ["CDP", "campaign"]
      },
      startDate: campaignData.startDate,
      endDate: campaignData.endDate,
      enabled: campaignData.enabled,
      segments: campaignData.segments
    }),
  });
  return response.json();
};

export const deleteCampaign = async (campaignId) => {
  return fetch(`${BASE_URL}/campaigns/${campaignId}`, {
    method: "DELETE",
    headers: authHeader,
  });
};

// Add scoring plan related functions
export const fetchScoringPlans = async () => {
  const response = await fetch(`${BASE_URL}/scoring/search`, {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      offset: 0,
      limit: 50,
      condition: {
        type: "booleanCondition",
        parameterValues: {
          operator: "and",
          subConditions: []
        }
      }
    }),
  });
  return response.json();
};

export const createScoringPlan = async (planData) => {
  const response = await fetch(`${BASE_URL}/scoring`, {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      metadata: {
        id: planData.name.toLowerCase().replace(/\s+/g, '-'),
        name: planData.name,
        description: planData.description,
        scope: "CDP",
        tags: ["CDP", "scoring"]
      },
      elements: planData.elements
    }),
  });
  return response.json();
};

export const deleteScoringPlan = async (planId) => {
  return fetch(`${BASE_URL}/scoring/${planId}`, {
    method: "DELETE",
    headers: authHeader,
  });
};

// Add these goal-related functions
export const fetchGoals = async () => {
  const response = await fetch(`${BASE_URL}/goals/search`, {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      offset: 0,
      limit: 50,
      condition: {
        type: "booleanCondition",
        parameterValues: {
          operator: "and",
          subConditions: []
        }
      }
    }),
  });
  return response.json();
};

export const createGoal = async (goalData) => {
  const response = await fetch(`${BASE_URL}/goals`, {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      metadata: {
        id: goalData.name.toLowerCase().replace(/\s+/g, '-'),
        name: goalData.name,
        description: goalData.description,
        scope: "CDP",
        tags: ["CDP", "goal"]
      },
      targetValue: goalData.targetValue,
      matchType: goalData.matchType,
      condition: goalData.condition
    }),
  });
  return response.json();
};

export const updateGoal = async (goalId, goalData) => {
  const response = await fetch(`${BASE_URL}/goals/${goalId}`, {
    method: "PUT",
    headers: authHeader,
    body: JSON.stringify({
      metadata: {
        id: goalId,
        name: goalData.name,
        description: goalData.description,
        scope: "CDP",
        tags: ["CDP", "goal"]
      },
      targetValue: goalData.targetValue,
      matchType: goalData.matchType,
      condition: goalData.condition
    }),
  });
  return response.json();
};

export const deleteGoal = async (goalId) => {
  return fetch(`${BASE_URL}/goals/${goalId}`, {
    method: "DELETE",
    headers: authHeader,
  });
};

// Add analytics-related functions
export const fetchAnalytics = async (timeRange) => {
  const response = await fetch(`${BASE_URL}/analytics/search`, {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      timeRange,
      metrics: ["eventTrends", "profileGrowth", "segmentDistribution", "conversionRates"]
    }),
  });
  return response.json();
};

// Add system settings related functions
export const fetchSystemSettings = async () => {
  const response = await fetch(`${BASE_URL}/system/settings`, {
    headers: authHeader
  });
  return response.json();
};

export const updateSystemSettings = async (section, settings) => {
  const response = await fetch(`${BASE_URL}/system/settings/${section}`, {
    method: "PUT",
    headers: authHeader,
    body: JSON.stringify(settings),
  });
  return response.json();
};

// Add system monitoring related functions
export const fetchSystemStatus = async () => {
  const response = await fetch(`${BASE_URL}/system/status`, {
    headers: authHeader
  });
  return response.json();
};

export const fetchSystemMetrics = async () => {
  const response = await fetch(`${BASE_URL}/system/metrics`, {
    headers: authHeader
  });
  return response.json();
};
